import * as React from 'react';
import { Link } from 'react-router-dom';
import PromoCard from '../../components/PromoCard';

export default () => (
  <PromoCard
    image_url="/images/stats.png"
    title="Guide through your coffee"
    subtitle="Use brew guides to train your wholesale customers and/or Filtru users that brew your coffee"
  >
    <p className="ma0 mt3 mt4-l">
      <Link
        to="/guides"
        className="f5 link dim br-pill bg-black-10 hover-bg-black-20 ph4 pv3 mh1 dib bw0 pointer black b"
      >
        Get Started
      </Link>
    </p>
  </PromoCard>
);
